// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"1fc6b241","612":"d9df08b8","722":"6e9befc5","1470":"6e9befc5","1545":"d9df08b8","1938":"d9df08b8","4572":"6e9befc5","5478":"d9df08b8","6152":"6e9befc5"}[chunkId] + ".chunk.css";
};